import React from 'react';
import '../../../styles/Auction.css';
import AuctionSessionCard from './AuctionSessionCard';

const AuctionSessionList = ({ sessions, onEdit, onDelete }) => {
    if (!sessions || sessions.length === 0) {
        return (
            <div className="auction-session-list">
                <div className="no-sessions">
                    <p>No auction sessions found.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="auction-session-list">
            {sessions.map(session => (
                <AuctionSessionCard key={session.session_id} session={session} onEdit={onEdit} onDelete={onDelete} />
            ))}
        </div>
    );
};

export default AuctionSessionList;